import * as React from 'react';
import './Tiles.scss';
import Tile from '../Tile/Tile';
import { CLASSNAME_PREFIX } from '../../componentConfig';
function Tiles(_a) {
    var data = _a.data, clickHandler = _a.clickHandler, translate = _a.t;
    return (React.createElement("div", { className: CLASSNAME_PREFIX + "-tiles" }, data &&
        data.map(function (_a, index) {
            var status = _a.status, scenarioType = _a.scenarioType, _b = _a.payload, verificationType = _b.verificationType, supportedDocuments = _b.supportedDocuments, tileType = _b.tileType;
            return (React.createElement(Tile, { key: index, handler: clickHandler, t: translate, opts: {
                    verificationType: verificationType,
                    scenarioType: scenarioType,
                    status: status,
                    index: index + 1,
                    documents: supportedDocuments,
                    prefix: tileType,
                } }));
        })));
}
export default Tiles;
//# sourceMappingURL=Tiles.js.map